import React, { FunctionComponent } from 'react';
import { ProductDetailsContentAccordionStyles as S } from './ProductDetailsContentAccordion.styles';

export interface ProductDetailsContentAccordionProps {
  title?: string;
  sticky?: boolean;
}

const ProductDetailsContentAccordion: FunctionComponent<ProductDetailsContentAccordionProps> = (props) => {
  return (
    <S.Container sticky={props.sticky}>
      {props.title && <S.Header>{props.title}</S.Header>}
      <S.Content>{props.children}</S.Content>
    </S.Container>
  );
};

export default ProductDetailsContentAccordion;
